import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const LandscapeIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0526 1.5H0.947368L0.947368 14.5H17.0526V1.5ZM0.947368 0.5C0.424151 0.5 0 0.947715 0 1.5V14.5C0 15.0523 0.424151 15.5 0.947368 15.5H17.0526C17.5758 15.5 18 15.0523 18 14.5V1.5C18 0.947715 17.5758 0.5 17.0526 0.5H0.947368Z'
        fill={stroke}
      />
      <path
        d='M6.5 5C6.5 6.10457 5.60457 7 4.5 7C3.39543 7 2.5 6.10457 2.5 5C2.5 3.89543 3.39543 3 4.5 3C5.60457 3 6.5 3.89543 6.5 5Z'
        fill={stroke}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.5 6C5.05228 6 5.5 5.55228 5.5 5C5.5 4.44772 5.05228 4 4.5 4C3.94772 4 3.5 4.44772 3.5 5C3.5 5.55228 3.94772 6 4.5 6ZM4.5 7C5.60457 7 6.5 6.10457 6.5 5C6.5 3.89543 5.60457 3 4.5 3C3.39543 3 2.5 3.89543 2.5 5C2.5 6.10457 3.39543 7 4.5 7Z'
        fill={stroke}
      />
      <path
        d='M2.5 11.4998L5.65714 7.9998L7.14286 9.7998L11.7857 4.7998L15.5 8.9998V12.9998H2.5V11.4998Z'
        fill={stroke}
      />
    </svg>
  )
}
